const articleContent = document.querySelector(".article-content")
const swiper = articleContent.querySelectorAll(".Swiper")
const beforeAfter = articleContent.querySelectorAll(".BeforeAfter")
const paginationHtml = `<div class="swiper-pagination is-relative"></div>`
const nextButtonHtml = `<div class="swiper-button-next"><div class="swiper-button-next-arrow"></div></div>`
const prevButtonHtml = `<div class="swiper-button-prev"><div class="swiper-button-prev-arrow"></div></div>`
const scrollbarHtml = `<div class="scrollbar-container"><div class="swiper-scrollbar"></div></div>`

const fullBreakpoints = {
  1400: {
    slidesPerView: 1,
  },
}

const defaultBreakpoints = {
  320: {
    slidesPerView: 1.5,
    spaceBetween: 10,
  },
  600: {
    slidesPerView: 2,
    spaceBetween: 10,
  },
  993: {
    slidesPerView: 2,
    spaceBetween: 10,
  },
  1400: {
    slidesPerView: 2,
    spaceBetween: 10,
  },
}

const sliderOptions = {
  freeMode: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  mousewheel: {
    forceToAxis: true,
  },
  watchOverflow: true,
  centerInsufficientSlides: true,
}

if (swiper) {
  swiper.forEach((swiper, index) => {
    const childs = [...swiper.children]
    const isFull = swiper.classList.contains("Full")
    const hasPagination = swiper.classList.contains("Pagination")
    const hasArrows = swiper.classList.contains("Arrows")

    swiper.classList.remove("Swiper", "Pagination", "Full", "Arrows")
    swiper.classList.add("swiper-container", `article-swiper-${index}`)
    swiper.innerHTML = `<div class="swiper-wrapper">
                          ${childs
                            .map(
                              (
                                child
                              ) => `<div onclick="togglePlay(event)" class="swiper-slide is-clickable">
                                      ${child.outerHTML}
                                      ${
                                        child.nodeName === "VIDEO"
                                          ? `<button aria-label="Play" class="video-button"><img src="https://cdn.shopify.com/s/files/1/2567/9006/files/icon-play_91bf57da-88cf-4cbc-aebb-fdd104008d50.svg?v=1661807208" alt=""></button>`
                                          : ""
                                      }
                                    </div>`
                            )
                            .join("")}
                        </div> 
                        ${hasPagination ? paginationHtml : scrollbarHtml}
                        ${hasArrows ? nextButtonHtml + prevButtonHtml : ""}`

    if (isFull) {
      sliderOptions.breakpoints = fullBreakpoints
      sliderOptions.spaceBetween = 0
    } else {
      sliderOptions.breakpoints = defaultBreakpoints
      sliderOptions.spaceBetween = 10
    }

    if (hasPagination) {
      sliderOptions.scrollbar = {}
      sliderOptions.pagination = {
        el: `.article-swiper-${index} .swiper-pagination`,
        type: "bullets",
        clickable: true,
      }
    } else {
      sliderOptions.pagination = {}
      sliderOptions.scrollbar = {
        el: `.article-swiper-${index} .swiper-scrollbar`,
        freeMode: true,
        draggable: true,
        hide: false,
      }
    }

    if (hasArrows) {
      sliderOptions.navigation = {
        nextEl: `.article-swiper-${index} .swiper-button-next`,
        prevEl: `.article-swiper-${index} .swiper-button-prev`,
      }
    } else {
      sliderOptions.navigation = {}
    }

    new Swiper(`.article-swiper-${index}`, sliderOptions)
  })
}

if (beforeAfter) {
  beforeAfter.forEach((beforeAfter, index) => {
    const childs = [...beforeAfter.children]
    const width = childs[0].width
    const height = childs[0].height

    beforeAfter.innerHTML = `
      <style>
        input.Range-BA::-webkit-slider-thumb {
          height: ${height}px;
        }
        input.Range-BA::-moz-range-thumb {
          height: ${height}px;
        }
        .Container-BA {
          width: ${width}px;
          height: ${height}px;
        }
        .Img-BA {
          background-size: ${width}px 100%;
        }
      </style>
      <div class='Container-BA'>
        ${childs
          .map((child, index) => {
            const isLast = index === childs.length - 1
            return `<div style="background-image: url('${
              child.src
            }');" class='Img-BA ${isLast ? "Foreground-BA" : "After-BA"}'>
              <p>${isLast ? "BEFORE" : "AFTER"}</p>
            </div>`
          })
          .join("")}
        <input type="range" min="1" max="100" value="50" class="Range-BA" name='Range-BA-${index}'>
        <div class='Range-Button-BA'></div>
      </div>
    `
  })
}

const togglePlay = (event) => {
  let container = event.target.parentElement
  if (event.target.nodeName === "IMG") {
    container = event.target.parentElement.parentElement
  }
  const button = container.querySelector("button")
  const video = container.querySelector("video")
  const isPlaying = video.paused

  if (isPlaying) {
    video.play()
    button.classList.add("is-hidden")
  } else {
    video.pause()
    button.classList.remove("is-hidden")
  }
}

const checkSwiperVisibility = () => {
  const scrollbars = document.querySelectorAll(".scrollbar-container")
  scrollbars.forEach((scrollbar) => {
    if (scrollbar.querySelector(".swiper-scrollbar-lock")) {
      scrollbar.style.display = "none"
    } else {
      scrollbar.style.display = "block"
    }
  })
}

checkSwiperVisibility()
window.addEventListener("resize", checkSwiperVisibility)

$(".Range-BA").on("input change", (e) => {
  const sliderPos = e.target.value
  $(".Foreground-BA").css("width", `${sliderPos}%`)
  $(".Range-Button-BA").css("left", `calc(${sliderPos}% - 18px)`)
})
